import {Question, Serializer, SurveyModel} from "survey-core";
import {Contact} from "../backend/backendapi";

export function registerSurveyCustomDropdownProperties(): void {
    Serializer.addProperty('dropdown', {
        name: 'customRbContactsDropdown',
        category: 'choices',
        type: 'boolean',
        visibleIndex: 10,
        default: false,
    });
}

export function registerSurveyCustomDropdownPropertiesTranslation(): void {
  // DO NOT LOAD in survey view-only mode, as it will throw an error because the creator chunk is not loaded
  // Dynamically import editor utils only when explicit registration is called
  import('./creator/Creator/utils-editor').then(({ registerPropertyTranslations }) => {
    registerPropertyTranslations('customRbContactsDropdown', {
      en: 'Fetch choices dynamically',
      de: 'Kontakte anzeigen',
      hu: 'Névjegyek megjelenítése',
      sl: 'Prikaži stike',
      hr: 'Prikaži kontakte',
    });
  }).catch(() => {
    // Gracefully handle view-only environments where creator chunk is not loaded
  });
}

export function applyCustomDropdownChoices(survey: SurveyModel, contacts: Contact[]): void {

    const fetchChoicesForQuestion = (q: Question) => {
        q.choices = contacts.map((contact: Contact) => {
            const name = [contact.firstName, contact.lastName]
                .filter(Boolean)
                .join(" ");

            const emailPart = contact.email ? ` (${contact.email})` : "";

            return name || contact.email
                ? `${name}${emailPart}`.trim()
                : "";
        });
    };
    
    // fetch on initial load
    survey.onAfterRenderSurvey.add(() => {
        survey
            .getAllQuestions()
            .filter(q =>
                q.getType() === 'dropdown' &&
                q.getPropertyValue('customRbContactsDropdown') === true
            ).forEach(fetchChoicesForQuestion);
    });
}

export function hasContactsField(json: string): boolean {
    //try catch just in case something goes wrong in parsing
    try {
        const obj = JSON.parse(json);

        const processElements = (elements: any[]): boolean => {
            if (!elements) return false;
            for (const element of elements) {
                if (element.type === 'panel' && element.elements) {
                    let entryFound = processElements(element.elements); // recurse panels
                    if (entryFound)
                        return true;
                }
                if (
                    element.type === 'dropdown' &&
                    element.customRbContactsDropdown === true
                ) {
                    return true;
                }
            }
            return false;
        };

        for (const page of obj.pages ?? []) {
            let entryFound = processElements(page.elements ?? []);
            if (entryFound) return true;
        }

        return false;
    } catch (e) {
        return false;
    }
}